
import React from 'react'
import { OverViewDatePicker } from '../DatePicker'

function Header({ text }) {
    return (
        <div className='flex justify-between border-b h-[60px]'>
            <div className='text-[#657585] text-[20px] font-[700]'>{text}</div>
            <div>

                <OverViewDatePicker getRange={(data) => console.log(data,'kekekekekekekekekekek')} />

            </div>
        </div>
    )
}

export default Header